import { Component, ViewChild, Pipe, PipeTransform } from '@angular/core';
import { Router } from '@angular/router';

import { LoginService } from 'app/view/login/login.service';
declare var $: any;

import { Loader } from './../loader/oh.loader';

import { CSECoreService } from './../cse.coreService';

@Pipe({
	name: 'pointD'
})

export class pointD implements PipeTransform {
	transform(value: string, args: any[]): string {
		if (value) {
			return value.replace(',', '.');
		}
		return '';
	}
}

@Component({
	moduleId: module.id,
	selector: 'main-app',
	templateUrl: '../../templates/main.component.html',
	styleUrls: ['../../assets/css/main.component.css'],
	providers: [LoginService]
})

export class MainComponent {

	title = 'main';
	fecha: string = "de";

	@ViewChild("loaderId") objLoader: Loader;

	constructor(private loginService: LoginService, private router: Router, private cseCore: CSECoreService) {

	}

	Logout() {
		this.loginService.logout();
		this.router.navigate(['/iniciar-sesion']);
	}

	dragSidebar() {
		//console.log("entre");
		$(".box-sidebar").toggleClass("Drag");
		$(".box-main").toggleClass("Drag");
	}

	closeInfoShow() {
		$(".box-info_contendor").removeClass("box-info_contendorShow");
		$(".box-detalles").removeClass("paddingRigth");
	}

	ngOnInit() {
		this.cseCore.setLoader(this.objLoader);
	}
}








// WEBPACK FOOTER //
// C:/carlos/wks/web/vacios_web/src/app/component/main.component.ts